import React from 'react';
import { AssetBlockProps } from '../../pages/AssetApp';
import { TextBlock } from '../TextBlock';
import ProfileAssetHeading from './ProfileAssetHeading';

const PrimaryPartner: React.FC<AssetBlockProps> = ({ asset }) => {
  return (
    <div>
      <ProfileAssetHeading heading={asset.primaryPartner?.heading} />
      {asset?.primaryPartner?.logo?.file?.url && (
        <div
          style={{
            alignItems: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'center',
            paddingTop: 20,
          }}>
          <div
            style={{
              padding: 10,
              width: 200,
            }}>
            <img src={asset.primaryPartner.logo.file.url} width="100%" />
          </div>
        </div>
      )}
      <TextBlock size={16}>{asset.primaryPartner?.description}</TextBlock>
    </div>
  );
};

export default PrimaryPartner;
